import { Check, ShieldCheck } from "lucide-react";
import { BENEFITS } from "../data/content";
import { Reveal, SectionHead } from "./Reveal";

export const Benefits = () => (
  <section id="vorteile" className="relative py-28 lg:py-40" data-testid="benefits-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <SectionHead eyebrow="Ihre Vorteile" lines={["Vertrauenswürdig", "durch nachweisbare", "Qualität."]} />
        <Reveal delay={0.2}>
          <div className="card-glass p-8 max-w-md" data-testid="founder-card">
            <div className="flex items-center gap-4 mb-5">
              <img src="/images/logo-mark.png" alt="" className="h-10 w-auto" />
              <div>
                <p className="eyebrow !text-[0.6rem]">Wer steckt dahinter?</p>
                <p className="font-display text-xl mt-1">Mustafa Salgin, Gründer</p>
              </div>
            </div>
            <p className="text-sm text-[var(--muted)] leading-relaxed">
              „Ich unterstütze Unternehmen, Händler und Marken dabei, ihre Produkte professionell zu präsentieren. Mein Fokus liegt auf modernen KI-gestützten Produktvisualisierungen, die individuell erstellt und für den jeweiligen Einsatzzweck optimiert werden.“
            </p>
            <div className="mt-6 flex items-center gap-2 text-[0.65rem] font-mono uppercase tracking-[0.2em] text-[var(--gold)]">
              <ShieldCheck size={14} /> Bad Oeynhausen · Deutschland
            </div>
          </div>
        </Reveal>
      </div>
      <div className="lg:col-span-7 lg:pt-8">
        <ul className="grid sm:grid-cols-2 gap-px bg-[var(--line)] border border-[var(--line)]" data-testid="benefits-grid">
          {BENEFITS.map((b, i) => (
            <Reveal key={b} delay={i * 0.06} y={16} className="bg-[var(--bg)]">
              <li className="h-full p-7 lg:p-8 flex items-start gap-4 group hover:bg-[rgba(212,175,55,0.04)] transition-colors duration-500" data-testid={`benefit-item-${i}`}>
                <span className="mt-1 w-7 h-7 shrink-0 border border-[var(--line-strong)] flex items-center justify-center text-[var(--gold)] group-hover:bg-[var(--gold)] group-hover:text-[#0a0a0b] transition-colors duration-500">
                  <Check size={13} />
                </span>
                <div>
                  <p className="font-mono text-[0.6rem] tracking-[0.2em] text-[var(--muted-2)] mb-1">0{i + 1}</p>
                  <p className="font-display text-xl leading-tight">{b}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </div>
  </section>
);
